<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">APHT Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/invoice-apht/created">
            <CIcon name="cil-credit-card" />
            Created
          </b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'Invoice APHT Memo List', params: { collateralId: $route.params.collateralId } }">Memo</b-breadcrumb-item>
          <b-breadcrumb-item active>Detail</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow class="mx-2">
      <CCol class="col-12 col-md-6 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-9">
                <h5 class="custom-header-display">Data FIFApps</h5>
              </CCol>
              <CCol class="col-3">
                <CButton color="primary" class="float-right" style="min-width:40px;" @click="refreshVendorId" :disabled="$helper.isEmpty(details.vendorId)">
                  <b-spinner small v-if="isVendorRefreshing" />
                  <CIcon name="cil-reload" v-else />
                </CButton>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="pt-2 custom-detail-list">
                <CRow v-if="isLoadingAPHT">
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>ID Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorId, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Nama Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorName, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Bank Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorBank, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Akun Bank Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorBankAccount, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Nama Akun Bank</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorAccountName, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-4">
                    <p>Status Vendor</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-8">
                    <p>: {{ $helper.showData(details.vendorStatus, "string") }}</p>
                  </CCol>
              </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
        <CCard class="custom-form-card custom-card mt-2">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data Kolateral</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="pt-2 custom-detail-list">
                <CRow v-if="isLoadingAPHT">
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Sertifikat Tanah</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.nomorSertifikatTanah, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Nama Sertifikat Tanah</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.namaSertifikatTanah, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Status Hak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.statusHak, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Nilai Appraisal</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.nilaiAppraisal, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Sertifikat HT</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.certificateNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tanggal Sertifikat HT</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.certificateDate, "shortDate") }}</p>
                  </CCol>
              </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="col-12 col-md-6 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data FIMS</h5>
              </CCol>
              <CCol class="col-12 pt-2 custom-detail-list">
                <CRow v-if="isLoadingAPHT">
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tipe Kontrak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: APHT</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Kontrak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.contractNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Memo</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.invoiceMemoNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>No. Appl</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.applNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Nama Office</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.officeName, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Status</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.memoStatusDisplay, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tanggal Pembuatan</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.createdAt, "shortDate") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Biaya Notaris</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.notaryFee, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Biaya Materai</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.materaiFee, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Biaya PNBP</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.pnbpFee, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Pokok Pembiayaan</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp {{ $helper.showData(details.pokokPembiayaan, "number") }}</p>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-2 mx-2">
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Notes</h5>
              </CCol>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6" v-if="isLoadingAPHT">
                <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
              </CCol>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6" v-else>
                {{ $helper.showData(details.notes, "string") }}
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-2 mx-2">
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Approval Berjenjang</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="col-12 pt-2 custom-detail-list">
                <template v-if="isLoadingAPHT">
                  <CRow v-for="index in 5" :key="index">
                    <CCol class="col-7 col-xs-7 col-sm-6 col-md-7 col-lg-7 col-xl-6 mb-1">
                      <CRow>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-8 col-lg-12 col-xl-8">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-12 col-xl-4">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                      </CRow>
                    </CCol>
                  </CRow>
                </template>
                <template v-else>
                  <CRow v-for="(item, index) in details.approvalBerjenjang" :key="'approval-' + index">
                    <CCol class="col-4">
                      <strong v-if="item.level === details.approvalLevel">Level {{ item.level }}</strong>
                      <template v-else>Level {{ item.level }}</template>
                    </CCol>
                    <CCol class="col-8">
                      <strong v-if="item.level === details.approvalLevel">
                        : 
                        <span v-for="(value, index2) in item.values" :key="'approval-value-' + index2">
                          {{ index2 != 0 ? ', ' : '' }}{{ value.text }}
                        </span>
                      </strong>
                      <template v-else>
                        : 
                        <span v-for="(value, index2) in item.values" :key="'approval-value-' + index2">
                          {{ index2 != 0 ? ', ' : '' }}{{ value.text }}
                        </span>
                      </template>
                    </CCol>
                  </CRow>
                </template>
              </CCol>
            </CRow>
            <CRow class="mt-4 mb-0 pb-0" v-if="details.memoStatus == 'RJ' || details.memoStatus == 'RV'">
              <CCol>
                <b-alert show variant="warning" v-if="details.memoStatus == 'RV'">
                  <span v-if="!$helper.isEmpty(details.reviseRequestByName)">({{ details.reviseRequestByName }}) </span>
                  <span v-if="!$helper.isEmpty(details.reviseNotes)">{{ details.reviseNotes }}</span>
                </b-alert>
                <b-alert show variant="danger" v-if="details.memoStatus == 'RJ'">
                  <span v-if="!$helper.isEmpty(details.rejectedByName)">({{ details.rejectedByName }}) </span>
                  <span v-if="!$helper.isEmpty(details.rejectNotes)">{{ details.rejectNotes }}</span>
                </b-alert>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <template v-if="$helper.isRole($availRoles['Cabang'])">
        <template v-if="isLoadingAPHT">
          <CCol class="col-3 offset-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 offset-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 offset-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 offset-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
        </template>
        <CCol class="col-12 mt-4" v-else>
          <template v-if="details.creator">
            <b-btn type="button" variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.reviseAPHT" v-if="details.memoStatus == 'RV'" @click="$router.push({ name: 'Invoice APHT Edit', params: { collateralId: $route.params.collateralId , invoiceMemoNo: $route.params.invoiceMemoNo } })">
              <b-spinner small v-if="isSubmitting.reviseAPHT" />
              <span v-else>Revise APHT</span>
            </b-btn>
          </template>
          <b-btn type="button" variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:11.2rem" :title="$helper.isEmpty(details.certificateLandFileId) ? 'Certificate unavailable' : 'Download Sertifikat Tanah'" :disabled="$helper.isEmpty(details.certificateLandFileId) || isDownloading.certificateLandFileId" @click="downloadCertificateLandFile">
            <b-spinner small v-if="isDownloading.certificateLandFileId" />
            <span v-else>Download Sertifikat Tanah</span>
          </b-btn>
          <b-btn type="button" variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:11.2rem" :title="$helper.isEmpty(details.certificateHtFileId) ? 'Certificate unavailable' : 'Download Sertifikat HT'" :disabled="$helper.isEmpty(details.certificateHtFileId) || isDownloading.certificateHtFileId" @click="downloadCertificateHTFile">
            <b-spinner small v-if="isDownloading.certificateHtFileId" />
            <span v-else>Download Sertifikat HT</span>
          </b-btn>
          <b-btn type="button" variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:11.2rem" :title="$helper.isEmpty(details.covernoteFileId) ? 'Cover Note unavailable' : 'Download Cover Note'" :disabled="$helper.isEmpty(details.covernoteFileId) || isDownloading.covernoteFileId" @click="downloadCoverNoteFile">
            <b-spinner small v-if="isDownloading.covernoteFileId" />
            <span v-else>Download Cover Note</span>
          </b-btn>
        </CCol>
      </template>
      <template v-else-if="$helper.isRole($availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])">
        <template v-if="isLoadingAPHT">
          <CCol class="col-3 offset-9 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 offset-9 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 offset-9 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 offset-9 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
        </template>
        <CCol class="col-12 mt-4" v-else>
          <b-btn type="button" variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:11.2rem" :title="$helper.isEmpty(details.certificateLandFileId) ? 'Certificate unavailable' : 'Download Sertifikat Tanah'" :disabled="$helper.isEmpty(details.certificateLandFileId) || isDownloading.certificateLandFileId" @click="downloadCertificateLandFile">
            <b-spinner small v-if="isDownloading.certificateLandFileId" />
            <span v-else>Download Sertifikat Tanah</span>
          </b-btn>
          <b-btn type="button" variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:11.2rem" :title="$helper.isEmpty(details.certificateHtFileId) ? 'Certificate unavailable' : 'Download Sertifikat HT'" :disabled="$helper.isEmpty(details.certificateHtFileId) || isDownloading.certificateHtFileId" @click="downloadCertificateHTFile">
            <b-spinner small v-if="isDownloading.certificateHtFileId" />
            <span v-else>Download Sertifikat HT</span>
          </b-btn>
          <b-btn type="button" variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:11.2rem" :title="$helper.isEmpty(details.covernoteFileId) ? 'Cover Note unavailable' : 'Download Cover Note'" :disabled="$helper.isEmpty(details.covernoteFileId) || isDownloading.covernoteFileId" @click="downloadCoverNoteFile">
            <b-spinner small v-if="isDownloading.covernoteFileId" />
            <span v-else>Download Cover Note</span>
          </b-btn>
          <b-btn type="button" variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:11.2rem" :disabled="isSubmitting.updateApproval || details.memoStatus != 'OA'" @click="showUpdateApprovalModal">
            <b-spinner small v-if="isSubmitting.updateApproval" />
            <span v-else>Update Approval</span>
          </b-btn>
        </CCol>
      </template>
    </CRow>
    
    <b-modal
      v-model="updateApprovalModalData.isShowing"
      title="Update Approval"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-footer
      hide-header-close
      scrollable
      size="xl"
    >
      <CForm>
        <CRow>
          <CCol class="col-12">
            <b-table striped hover show-empty
              responsive="xl"
              :items="updateApprovalModalData.table.items"
              :fields="updateApprovalModalData.table.fields"
              :busy="!updateApprovalModalData.table.isLoaded"
              no-local-sorting no-sort-reset
            >
              <template slot="empty">
                <div v-if="!updateApprovalModalData.table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(approveBy)="row">
                <b-form-select v-model="row.item.approveBy" :options="updateApprovalModalData.table.approveByOptions" @change="onChangeApproveBy(row.index)" style="max-width: 200px;"></b-form-select>
              </template>
              <template #cell(minPokokPembiayaan)="row">
                <b-form-group
                  class="mb-0"
                  :invalid-feedback="updateApprovalModalData.table.validationItems[row.index].minPokokPembiayaan.feedback"
                >
                  <b-form-input
                    :value="$helper.thousandSeparator(row.item.minPokokPembiayaan)"
                    :state="updateApprovalModalData.table.validationItems[row.index].minPokokPembiayaan.isValid"
                    :disabled="row.index == 0"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    @input="row.item.minPokokPembiayaan = $event.toString().replace(/\./g, '')"
                    maxlength="19"
                    type="text"
                    placeholder="Min Pokok Pembiayaan"
                    autocomplete="off"
                    style="max-width: 200px;"
                  ></b-form-input>
                </b-form-group>
              </template>
              <template #cell(values)="row">
                <b-form-group
                  class="mb-0"
                  v-if="row.item.approveBy == 'jobCode'"
                  :invalid-feedback="updateApprovalModalData.table.validationItems[row.index].values.feedback"
                  :state="updateApprovalModalData.table.validationItems[row.index].values.isValid"
                >
                  <multiselect 
                    v-model="row.item.values" 
                    :options="updateApprovalModalData.table.jobCodeData.options" 
                    class="mb-0"
                    :class="{custom_multiselect_invalid: updateApprovalModalData.table.validationItems[row.index].values.isValid === false}"
                    placeholder="Select an option"
                    :showLabels="false"
                    :loading="!updateApprovalModalData.table.jobCodeData.isLoaded"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                    :internalSearch="false"
                    :multiple="true"
                    :preserveSearch="false"
                    @search-change="populateJobCode"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="noResult">No elements found.</template>
                    <template slot="afterList" v-if="updateApprovalModalData.table.jobCodeData.currentPage < updateApprovalModalData.table.jobCodeData.totalPages">
                      <div class="text-center custom-cursor-clickable p-2" @click="appendJobCode" v-if="updateApprovalModalData.table.jobCodeData.isLoaded">
                        <span class="text-muted">Load More</span>
                      </div>
                      <div class="text-center" v-else>
                        <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                      </div>
                    </template>
                  </multiselect>
                </b-form-group>
                <b-form-group
                  class="mb-0"
                  v-else
                  :invalid-feedback="updateApprovalModalData.table.validationItems[row.index].values.feedback"
                  :state="updateApprovalModalData.table.validationItems[row.index].values.isValid"
                >
                  <multiselect 
                    v-model="row.item.values" 
                    :options="updateApprovalModalData.table.userData.options" 
                    class="mb-0"
                    :class="{custom_multiselect_invalid: updateApprovalModalData.table.validationItems[row.index].values.isValid === false}"
                    placeholder="Select an option"
                    :showLabels="false"
                    :loading="!updateApprovalModalData.table.userData.isLoaded"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                    :internalSearch="false"
                    :multiple="true"
                    :preserveSearch="false"
                    @search-change="populateUser"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="noResult">No elements found.</template>
                    <template slot="afterList" v-if="updateApprovalModalData.table.userData.currentPage < updateApprovalModalData.table.userData.totalPages">
                      <div class="text-center custom-cursor-clickable p-2" @click="appendUser" v-if="updateApprovalModalData.table.userData.isLoaded">
                        <span class="text-muted">Load More</span>
                      </div>
                      <div class="text-center" v-else>
                        <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                      </div>
                    </template>
                  </multiselect>
                </b-form-group>
              </template>
              <template #cell(action)="row">
                <b-button variant="danger" size="sm" title="Remove" @click="removeItem(row.index)" v-if="row.index >= approval.length">
                  <CIcon name="cil-minus"/>
                </b-button>
              </template>
              <template #head(action)>
                <b-button variant="primary" size="sm" title="Add New Row" @click="addItem"><CIcon name="cil-plus"/></b-button>
              </template>
            </b-table>
          </CCol>
        </CRow>
        <CRow class="mt-1 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="updateApprovalModalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="updateApprovalModalData.isSubmitting" @click="updateApproval">
              <b-spinner small v-if="updateApprovalModalData.isSubmitting" />
              <span v-else>Save</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceApprovedMemoDetail',
  data() {
    return {

      isLoadingAPHT: true,
      isVendorRefreshing: false,
      details: {},

      isSubmitting: {
        updateAPHT: false,
        reviseAPHT: false,
        updateApproval: false
      },
      isDownloading: {
        certificateHtFileId: false,
        certificateLandFileId: false,
        covernoteFileId: false,
      },

      approval: [],
      updateApprovalModalData: {
        isShowing: false,
        table: {
          isLoaded: false,
          fields: [
            {key: "level", label: "Level", sortable: false},
            {key: "approveBy", label: "Approve By", sortable: false},
            {key: "values", label: "Value", sortable: false},
            {key: "minPokokPembiayaan", label: "Min Pokok Pembiayaan", sortable: false},
            {key: "action", label: "", sortable: false}
          ],

          items: [],

          validationItems: [],

          template: {
            approveBy: "jobCode",
            level: 1,
            minPokokPembiayaan: 0,
            values: []
          },

          validationTemplate: {
            minPokokPembiayaan: {
              isValid: null,
              feedback: 'This input is required.',
              isRequired: true,
              payloadKey: "minPokokPembiayaan"
            },
            values: {
              isValid: null,
              feedback: 'This input is required.',
              isRequired: true,
              payloadKey: "values"
            },
          },

          approveByOptions: [
            { value: "jobCode", text: "Job Code" },
            { value: "user", text: "User" },
          ],

          jobCodeData: {
            isLoaded: false,
            isValid: null,
            isRequired: true,
            options: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            lastQuery: '',
          },

          userData: {
            isLoaded: false,
            isValid: null,
            isRequired: true,
            options: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            lastQuery: '',
          },

          currentPage: 1,
        },
        isSubmitting: false
      },

    }
  },
  methods: {

    getAPHT(){
      this.isLoadingAPHT = true
      let getUrl = "/aphtPayment/getMemoDetail"
      let params = {}
      params['invoiceMemoNo'] = this.$route.params.invoiceMemoNo
      this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.details = response.data.data
          this.details.approvalBerjenjang = JSON.parse(this.details.approvers)
          this.approval = this.details.approvalBerjenjang
          if(this.details.memoStatus == "OA"){
            this.details.memoStatusDisplay = "ON APPROVAL"
          }
          else if(this.details.memoStatus == "AP"){
            this.details.memoStatusDisplay = "APPROVED"
          }
          else if(this.details.memoStatus == "RJ"){
            this.details.memoStatusDisplay = "REJECTED"
          }
          else if(this.details.memoStatus == "RV"){
            this.details.memoStatusDisplay = "NEED REVISE"
          }
          else{
            this.details.memoStatusDisplay = "-"
          }
          // console.log(this.details)
        }
        else{
          this.$helper.toastError(this, "Load Detail Memo Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Detail Memo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Load Detail Memo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoadingAPHT = false
      })
    },

    onChangeApproveBy(index) {
      this.updateApprovalModalData.table.items[index].values = []
    },

    async showUpdateApprovalModal() {
      Promise.all([this.populateJobCode(), this.populateUser(), this.getTableItems()])
        .then(() => {
          for(let i = 0; i < this.updateApprovalModalData.table.validationItems.length; i++){
            this.updateApprovalModalData.table.validationItems[i].values.isValid = null
            this.updateApprovalModalData.table.validationItems[i].minPokokPembiayaan.isValid = null
          }
          this.updateApprovalModalData.isShowing = true
        })
    },

    getTableItems() {
      this.updateApprovalModalData.table.isLoaded = false

      this.updateApprovalModalData.table.items = this.$lodash.cloneDeep(this.approval)
      for(let i = 0; i < this.approval.length; i++) {
        this.addValidationItemOnly()
      }
      this.updateApprovalModalData.table.isLoaded = true
    },

    addValidationItemOnly() {
      let validationItem = this.$lodash.cloneDeep(this.updateApprovalModalData.table.validationTemplate)
      this.updateApprovalModalData.table.validationItems.push(validationItem)
    },

    async populateJobCode(query = "") {
      this.updateApprovalModalData.table.jobCodeData.isLoaded = false
      this.updateApprovalModalData.table.jobCodeData.totalPages = 0
      this.updateApprovalModalData.table.jobCodeData.totalRows = 0
      this.updateApprovalModalData.table.jobCodeData.currentPage = 1
      this.updateApprovalModalData.table.jobCodeData.lastQuery = query
      // URL builder
      let getUrl = "/approver/getJobCodeCabang"
      let params = {}
      // get content from current page
      params['page'] = (this.updateApprovalModalData.table.jobCodeData.currentPage - 1)
      params['size'] = this.updateApprovalModalData.table.jobCodeData.perPage
      if(query !== ""){
        params['filterType'] = "jobName"
        params['filterValue'] = query
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.updateApprovalModalData.table.jobCodeData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.updateApprovalModalData.table.jobCodeData.options.push({ value: response.data.data.data[i].jobCode, text: response.data.data.data[i].jobName })
            }
            this.updateApprovalModalData.table.jobCodeData.totalRows = response.data.data.totalElements
            this.updateApprovalModalData.table.jobCodeData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.updateApprovalModalData.table.jobCodeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    appendJobCode() {
      this.updateApprovalModalData.table.jobCodeData.isLoaded = false
      // URL builder
      let getUrl = "/approver/getJobCodeCabang"
      let params = {}
      // get content from next page
      params['page'] = (this.updateApprovalModalData.table.jobCodeData.currentPage)
      params['size'] = this.updateApprovalModalData.table.jobCodeData.perPage
      if(this.updateApprovalModalData.table.jobCodeData.lastQuery !== ""){
        params['filterType'] = "jobName"
        params['filterValue'] = this.updateApprovalModalData.table.jobCodeData.lastQuery
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.updateApprovalModalData.table.jobCodeData.options.push({ value: response.data.data.data[i].jobCode, text: response.data.data.data[i].jobName })
            }
            this.updateApprovalModalData.table.jobCodeData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.updateApprovalModalData.table.jobCodeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    async populateUser(query = "") {
      this.updateApprovalModalData.table.userData.isLoaded = false
      this.updateApprovalModalData.table.userData.totalPages = 0
      this.updateApprovalModalData.table.userData.totalRows = 0
      this.updateApprovalModalData.table.userData.currentPage = 1
      this.updateApprovalModalData.table.userData.lastQuery = query
      // URL builder
      let getUrl = "/approver/getUserCabang"
      let params = {}
      // get content from current page
      params['page'] = (this.updateApprovalModalData.table.userData.currentPage - 1)
      params['size'] = this.updateApprovalModalData.table.userData.perPage
      if(query !== ""){
        params['filterType'] = "fullName"
        params['filterValue'] = query
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.updateApprovalModalData.table.userData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.updateApprovalModalData.table.userData.options.push({ value: response.data.data.data[i].id, text: response.data.data.data[i].fullName })
            }
            this.updateApprovalModalData.table.userData.totalRows = response.data.data.totalElements
            this.updateApprovalModalData.table.userData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.updateApprovalModalData.table.userData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    appendUser() {
      this.updateApprovalModalData.table.userData.isLoaded = false
      // URL builder
      let getUrl = "/approver/getUserCabang"
      let params = {}
      // get content from next page
      params['page'] = (this.updateApprovalModalData.table.userData.currentPage)
      params['size'] = this.updateApprovalModalData.table.userData.perPage
      if(this.updateApprovalModalData.table.userData.lastQuery !== ""){
        params['filterType'] = "fullName"
        params['filterValue'] = this.updateApprovalModalData.table.userData.lastQuery
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.updateApprovalModalData.table.userData.options.push({ value: response.data.data.data[i].id, text: response.data.data.data[i].fullName })
            }
            this.updateApprovalModalData.table.userData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.updateApprovalModalData.table.userData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    removeItem(index) {
      this.updateApprovalModalData.table.items.splice(index, 1)
      this.updateApprovalModalData.table.validationItems.splice(index, 1)
      this.reorganizeItemLevels()

      if (index == 0) this.updateApprovalModalData.table.items[0].minPokokPembiayaan = 0
    },
    addItem() {
      let item = this.$lodash.cloneDeep(this.updateApprovalModalData.table.template)
      let validationItem = this.$lodash.cloneDeep(this.updateApprovalModalData.table.validationTemplate)
      item.level = (this.updateApprovalModalData.table.items.length+1)
      this.updateApprovalModalData.table.items.push(item)
      this.updateApprovalModalData.table.validationItems.push(validationItem)
    },
    
    updateApproval(event) {
      event.preventDefault()

      let isFormValid = true
      let obj = {}

      // Validation
      let index = 0
      let prevMinPokokPembayaran = 0
      for(const item of this.updateApprovalModalData.table.items) {
        if (item.values.length == 0) {
          this.updateApprovalModalData.table.validationItems[index].values.isValid = false
          isFormValid = false
        } else{
          this.updateApprovalModalData.table.validationItems[index].values.isValid = null
        }

        if (item.minPokokPembiayaan === '') {
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.feedback = "This input is required."
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.isValid = false
          isFormValid = false
        } else if (Number(item.minPokokPembiayaan) < prevMinPokokPembayaran) {
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.feedback = "Amount must be greater than or equals to previous amount."
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.isValid = false
          isFormValid = false
        } else{
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.isValid = null
        }

        prevMinPokokPembayaran = Number(item.minPokokPembiayaan)
        index++
      }

      if (isFormValid) {
        obj.approvers = this.updateApprovalModalData.table.items
        obj.invoiceMemoNo = this.$route.params.invoiceMemoNo
        let postUrl = '/aphtPayment/editApprovers'
        
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Set Approval Berjenjang Berhasil!" + (response.data.reason ? response.data.reason : ""))
              this.getAPHT()
              this.updateApprovalModalData.isShowing = false
            }
            else{
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    
    downloadCertificateLandFile() {
      let payload = new FormData()
      let postUrl = '/apht/downloadLandCertificate'
      payload.append("collateralAphtId", this.$route.params.collateralId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.isDownloading.certificateLandFileId = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.$route.params.collateralId + "-land-cert.pdf"
            link.click()
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Sertifikat Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isDownloading.certificateLandFileId = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    downloadCertificateHTFile() {
      let payload = new FormData()
      let postUrl = '/aphtPayment/downloadHTCertificate'
      payload.append("collateralAphtId", this.$route.params.collateralId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.isDownloading.certificateHtFileId = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.$route.params.collateralId + "-ht-cert.pdf"
            link.click()
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Sertifikat Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isDownloading.certificateHtFileId = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    downloadCoverNoteFile() {
      let payload = new FormData()
      let postUrl = '/aphtPayment/downloadCovernote'
      payload.append("collateralAphtId", this.$route.params.collateralId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.isDownloading.covernoteFileId = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.$route.params.collateralId + "-covernote.pdf"
            link.click()
          }
          else{
            this.$helper.toastError(this, "Download Cover Note Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Cover Note Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Cover Note Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isDownloading.covernoteFileId = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    // refresh vendor data based on id
    refreshVendorId() {
      let postUrl = '/aphtPayment/syncInvoiceMemoVendor'
      let payload = new FormData()
      payload.append("vendorId", this.details.vendorId)
      payload.append("invoiceMemoNo", this.$route.params.invoiceMemoNo)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.isVendorRefreshing = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.details.vendorName = response.data.data.namaVendor
            this.details.vendorBank = response.data.data.bank
            this.details.vendorBankAccount = response.data.data.noRek
            this.details.vendorAccountName = response.data.data.namaRek
            this.details.vendorStatus = response.data.data.statusRek
            this.details.vendorAddress = response.data.data.alamat
            this.details.vendorCity = response.data.data.kota
          }
          else{
            this.$helper.toastError(this, "Refresh Vendor gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Refresh Vendor gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Refresh Vendor gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.isVendorRefreshing = false
        })
      }
      else {
        this.$helper.toastError(this, "Access Denied!")
      }
    },
  },

  computed:{
    showRemoveButton(){
      if (this.updateApprovalModalData.table.items.length > 1) {
        return true
      } else{
        return false
      }
    }
  },

  mounted(){
    this.getAPHT()
  }
}
</script>

<style scoped>
</style>
